"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleUnaryCondition = void 0;
const market_rule_condition_1 = require("./market-rule-condition");
class MarketRuleUnaryCondition extends market_rule_condition_1.MarketRuleCondition {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        super(obj);
        if (obj) {
            this.conditionOperator = obj.conditionOperator;
            this.operand = obj.operand;
        }
    }
}
exports.MarketRuleUnaryCondition = MarketRuleUnaryCondition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUtdW5hcnktY29uZGl0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbnRlbnQvaGlzdG9yaWNhbC1wcmljaW5nL3RpbWUtc2VyaWVzL3NlcnZpY2VzL3J1bGUtZW5naW5lLXNlcnZpY2UvY2xhc3Nlcy9tYXJrZXQtcnVsZS11bmFyeS1jb25kaXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsbUVBQThEO0FBRTlELE1BQWEsd0JBQXlCLFNBQVEsMkNBQW1CO0lBSTdEOzs7T0FHRztJQUNILFlBQW1CLEdBQXVDO1FBQ3RELEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUVYLElBQUksR0FBRyxFQUFFLENBQUM7WUFDTixJQUFJLENBQUMsaUJBQWlCLEdBQUcsR0FBRyxDQUFDLGlCQUFrQixDQUFDO1lBQ2hELElBQUksQ0FBQyxPQUFPLEdBQUcsR0FBRyxDQUFDLE9BQVEsQ0FBQztRQUNoQyxDQUFDO0lBQ0wsQ0FBQztDQUNKO0FBaEJELDREQWdCQyJ9